import actions from './actions';
import answers from './answers';
import api from './api';
import error from './error';
import component from './component';
import application from './application';
import frame from './frame';
import { institutions } from './institutions';
import { segmentFeatureFlag, topSubjectsFeatureFlag } from './featureFlag';

export const atoms = {
  application,
  actions,
  answers,
  api,
  component,
  error,
  frame,
  institutions,
  segmentFeatureFlag,
  topSubjectsFeatureFlag,
};

export default atoms;
